import React, { Component } from "react";
import {
  Dimensions,
  ScrollView,
  StyleSheet,
  Text,
  Alert,
  ActivityIndicator,
  TextInput,
  Platform,
  TouchableOpacity,
  FlatList,
  DatePickerIOS,
  View
} from "react-native";
import { connect } from "react-redux";
import colors from "../constants/colors";
import moment from "moment-timezone";
import FormCard from "./widgets/formCard";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import Animations from "./animations"
import alerts from "./components/alert"
//import { Actions } from "react-native-router-flux";
import {
  setFilterSelected,
  setFormSelected,
  setTaskSelected,
  shouldReloadTasks,
  createNewTask,
  getTasks,
  setFormsFromAPI,
  quitOrderForm
} from "../actions/tasks";
import { setSubmissionSelected, setIsSubmission, getTeams, getProductionCategories } from "../actions/submissions";
import { navigateForm } from "../actions/menu";
import { color } from "react-native-reanimated";
import Swal from "sweetalert2";
import "./styles.css";
import { viewContainer } from "./functions";
import DropDown from "./widgets/dropdown";
import { setPromptTitle } from "../actions/tasks";
import { StackActions } from "@react-navigation/native";
import { branding, isBeta } from "../api";

function getTeamIcon(team = {}) {
  const name = (team.name || team.title || "").toLowerCase();
  if (name.includes("maintenance")) return "wrench";
  if (name.includes("operation")) return "account-group";
  if (name.includes("pest")) return "bug";
  if (name.includes("sanitation") || name.includes("sanit")) return "broom";
  return "account-group-outline";
}

function normalizeTeamId(value) {
  if (value == null) return null;
  if (typeof value === "string" || typeof value === "number") return String(value);
  if (typeof value === "object") {
    const id = value._id || value.id;
    return id != null ? String(id) : null;
  }
  return null;
}

function getFormTeams(form) {
  if (!form) return [];
  let teams = form.teams;
  if (teams == null && form.get) teams = form.get("teams");
  if (teams == null) return [];
  if (teams.toJS) teams = teams.toJS();
  if (Array.isArray(teams)) return teams;
  return [teams];
}

function formHasTeam(form, teamId) {
  if (!teamId) return true;
  const selected = String(teamId);
  return getFormTeams(form).some((t) => normalizeTeamId(t) === selected);
}

const PRODUCTION_INVENTORY_TYPES = ["Finished Goods", "Work in progress"];

function normalizeLabel(value) {
  return String(value || "").trim().toLowerCase();
}

function toPlainStringList(value) {
  if (!value) return [];
  if (value.toJS) value = value.toJS();
  if (!Array.isArray(value)) return [];
  return value
    .map((item) => {
      if (item == null) return "";
      if (typeof item === "string" || typeof item === "number") return String(item);
      return item.name || item.label || item.title || "";
    })
    .filter(Boolean);
}

function formMatchesProductionFilter(form, selected) {
  if (!selected) return true;
  const selectedKey = normalizeLabel(selected);
  const isInventoryType = PRODUCTION_INVENTORY_TYPES.some(
    (label) => normalizeLabel(label) === selectedKey
  );
  if (isInventoryType) {
    return normalizeLabel(form?.inventoryType) === selectedKey;
  }
  return toPlainStringList(form?.categories).some(
    (category) => normalizeLabel(category) === selectedKey
  );
}

function toPlainArray(value) {
  if (!value) return [];
  if (value.toJS) value = value.toJS();
  if (Array.isArray(value)) return value;
  if (Array.isArray(value.teams)) return value.teams;
  if (Array.isArray(value.data)) return value.data;
  return [];
}

class NewTask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      task_name: "",
      task_description: "",
      startDate: new Date(),
      expirationDate: new Date(),
      frequencies: [
        {
          text: "Day",
          isSelected: false,
        },
        {
          text: "Week",
          isSelected: false,
        },
        {
          text: "Month",
          isSelected: false,
        },
        {
          text: "Year",
          isSelected: false,
        },
      ],
      formData: this.props.formList,
      formFiltered: [],
      formSelected: {},
      isLoading: false,
      width: window.innerWidth,
      filterOptions: [
        { value: "Standard", filter: 'isStandard' },
        { value: "Recipe", filter: 'isRecipe' },
        // {value: "Ingredient", filter: 'isIngredient'},
        // {value: "Major Equipment", filter: 'isEquipment'},
        // {value: "Packaging Materials", filter: 'isPackaging'}
      ],
      filterValue: { value: "Standard", filter: 'isStandard' },
      searchString: "",
      formEnabled: true,
      selectedTeamId: null,
      selectedProductionCategory: null,
    };
    this.registerNewTask = this.registerNewTask.bind(this);
  }

  handleResize = () => {
    this.setState({ width: window.innerWidth });
  }

  changeButton = (number) => {
    let clone = this.state.frequencies;
    clone.map((item, index) => {
      if (index == number && !item.isSelected) {
        item.isSelected = true;
      } else if (item.isSelected && index != number) {
        item.isSelected = false;
      }
      return item;
    });
    this.setState({
      frequencies: clone,
    });
  };

  getTeamsList = () => toPlainArray(this.props.teams);

  selectTeam = (teamId) => {
    if (teamId == null || teamId === "all") {
      this.setState({ selectedTeamId: null }, () => {
        this.filterForms(this.state.searchString, this.state.filterValue);
      });
      return;
    }
    const id = normalizeTeamId(teamId);
    this.setState({ selectedTeamId: id }, () => {
      this.filterForms(this.state.searchString, this.state.filterValue);
    });
  };

  filterForms = (search, filterValue) => {
    let clone = [];
    const { route, navigation } = { ...this.props };
    const { category } = { ...(route?.params || {}) };
    const { selectedTeamId, selectedProductionCategory } = this.state;
    const isProduction = branding === "iqops" && this.props.formsFilter === "productionForms";
    const formData = branding === "iqops" ? toPlainArray(this.state.formData) : (this.state.formData || []);
    // iqops: category only when opened from AI submenu; otherwise API formsFilter owns scoping.
    // ghcs/gohaccp: preserve existing category == route.params.category prefilter.
    const preFilteredFomrs = branding === "iqops"
      ? (category ? formData.filter((form) => form?.promptMessages?.category == category) : formData)
      : formData.filter((form) => form?.promptMessages?.category == category);
    clone = preFilteredFomrs.filter((item) => {
      if (isProduction) {
        if (!formMatchesProductionFilter(item, selectedProductionCategory)) return false;
      } else if (branding === "iqops" && !formHasTeam(item, selectedTeamId)) {
        return false;
      }
      // iqops: Standard/Recipe type filter is disabled (same as iqops2-app)
      if (branding !== "iqops" && this.props.showTypesFilter && filterValue) {
        return (item.title || "").toLowerCase().includes((search || "").toLowerCase()) && item[filterValue.filter];
      }
      return (item.title || "").toLowerCase().includes((search || "").toLowerCase());
    });
    this.setState({ formFiltered: clone });
    if (preFilteredFomrs.length === 1) {
      if (typeof preFilteredFomrs[0]?.promptMessages != 'undefined') {
        if (!(preFilteredFomrs[0]?.promptMessages?.visible == false)) {
          this.props.setPromptTitle(preFilteredFomrs[0].name);
          setTimeout(() => {
            navigation.dispatch(StackActions.push('PromptFormView', { promptMessages: preFilteredFomrs[0]?.promptMessages, form: preFilteredFomrs[0] }));
          }, 200);
        }
      }
    }
  };

  selectForm = (number) => {
    let clone = JSON.parse(JSON.stringify(this.state.formFiltered));

    clone.map((item, index) => {
      if (index == number && item.isSelected == false) {
        item.isSelected = true;
      } else if (item.isSelected == true && index != number) {
        item.isSelected = false;
      }
      return item;
    });
    this.setState({
      formFiltered: clone,
    });

  };

  onFormPress = (item, index) => {
    const { formEnabled } = this.state;
    if (!formEnabled) return;
    this.setState({ formEnabled: false }, () => {
      if (item?.promptMessages?.category) {
        this.props.setPromptTitle(item.name);
        setTimeout(() => {
          this.props.navigation.dispatch(StackActions.push('PromptFormView', { promptMessages: item?.promptMessages, form: item }));
          this.setState({ formEnabled: true });
        }, 200);
        return;
      }
      // Prefer id-based selection so last-used / grouped lists keep correct selection.
      if (branding === "iqops" && item?._id != null) {
        const clone = toPlainArray(this.state.formFiltered).map((f) => ({
          ...f,
          isSelected: f._id === item._id,
        }));
        this.setState(
          { formFiltered: clone, formSelected: item },
          () => {
            this.registerNewTask();
            setTimeout(() => {
              this.setState({ formEnabled: true });
            }, 500);
          }
        );
        return;
      }
      this.selectForm(index);
      this.setState(
        { formSelected: item },
        () => {
          this.registerNewTask();
          setTimeout(() => {
            this.setState({ formEnabled: true });
          }, 500);
        }
      );
    });
  };

  renderTeamBubbles = () => {
    const teams = this.getTeamsList();
    if (!teams.length) return null;
    const { selectedTeamId } = this.state;
    const allActive = !selectedTeamId;

    return (
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        style={styles.teamBubblesScroll}
        contentContainerStyle={styles.teamBubblesContent}
      >
        <TouchableOpacity
          key="all"
          style={[styles.teamBubble, allActive && styles.teamBubbleActive]}
          activeOpacity={0.75}
          onPress={() => this.selectTeam("all")}
        >
          <MaterialCommunityIcons
            name="view-grid-outline"
            size={16}
            color={allActive ? "#FFFFFF" : "#5A6578"}
            style={styles.teamBubbleIcon}
          />
          <Text
            style={[styles.teamBubbleLabel, allActive && styles.teamBubbleLabelActive]}
            numberOfLines={1}
          >
            All
          </Text>
        </TouchableOpacity>
        {teams.map((team, index) => {
          const teamId = normalizeTeamId(team);
          if (!teamId) return null;
          const isActive = String(selectedTeamId) === teamId;
          const label = team?.name || team?.title || "Team";
          return (
            <TouchableOpacity
              key={`${teamId}-${index}`}
              style={[styles.teamBubble, isActive && styles.teamBubbleActive]}
              activeOpacity={0.75}
              onPress={() => this.selectTeam(teamId)}
            >
              <MaterialCommunityIcons
                name={getTeamIcon(team)}
                size={16}
                color={isActive ? "#FFFFFF" : "#5A6578"}
                style={styles.teamBubbleIcon}
              />
              <Text
                style={[styles.teamBubbleLabel, isActive && styles.teamBubbleLabelActive]}
                numberOfLines={1}
              >
                {String(label)}
              </Text>
            </TouchableOpacity>
          );
        })}
      </ScrollView>
    );
  };
  renderProductionCategoriesBubbles = () => {
    const categories = toPlainStringList(this.props.categories);
    const { selectedProductionCategory } = this.state;
    const allActive = !selectedProductionCategory;
    const chips = [...PRODUCTION_INVENTORY_TYPES, ...categories];
    return (
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        style={styles.teamBubblesScroll}
        contentContainerStyle={styles.teamBubblesContent}
      >
        <TouchableOpacity
          key="all"
          style={[styles.teamBubble, allActive && styles.teamBubbleActive]}
          activeOpacity={0.75}
          onPress={() => this.selectCategory(null)}
        >
          <MaterialCommunityIcons
            name="view-grid-outline"
            size={16}
            color={allActive ? "#FFFFFF" : "#5A6578"}
            style={styles.teamBubbleIcon}
          />
          <Text
            style={[styles.teamBubbleLabel, allActive && styles.teamBubbleLabelActive]}
            numberOfLines={1}
          >
            All
          </Text>
        </TouchableOpacity>
        {chips.map((category, index) => {
          const isActive = normalizeLabel(selectedProductionCategory) === normalizeLabel(category);
          return (
            <TouchableOpacity
              key={`${category}-${index}`}
              style={[styles.teamBubble, isActive && styles.teamBubbleActive]}
              activeOpacity={0.75}
              onPress={() => this.selectCategory(category)}
            >
              <Text
                style={[styles.teamBubbleLabel, isActive && styles.teamBubbleLabelActive]}
                numberOfLines={1}
              >
                {category}
              </Text>
            </TouchableOpacity>
          );
        })}
      </ScrollView>
    );
  };
  selectCategory = (category) => {
    this.setState({ selectedProductionCategory: category || null }, () => {
      this.filterForms(this.state.searchString, this.state.filterValue);
    });
  };


  renderFormCard = (item, index, options = {}) => (
    <FormCard
      key={item._id || item.title || index}
      action={() => this.onFormPress(item, index)}
      index={index}
      formTitle={item.title}
      formDescription={item.description}
      formImageUri={item.image}
      isSelected={item.isSelected}
      formEnabled={this.state.formEnabled}
      lastUsed={!!options.lastUsed}
      grouped={!!options.grouped}
      isLastInGroup={!!options.isLastInGroup}
    />
  );

  renderIqopsFormsList = () => {
    const formFiltered = toPlainArray(this.state.formFiltered);
    const lastUsed = formFiltered.filter((f) => f?.lastFormsUsed);
    const otherForms = formFiltered.filter((f) => !f?.lastFormsUsed);

    return (
      <>
        {lastUsed.length > 0 ? (
          <View style={styles.lastUsedSection}>
            <Text style={styles.lastUsedTitle}>Last Used Forms</Text>
            <View style={styles.lastUsedGroup}>
              {lastUsed.map((item, index) =>
                this.renderFormCard(item, index, {
                  lastUsed: true,
                  grouped: true,
                  isLastInGroup: index === lastUsed.length - 1,
                })
              )}
            </View>
          </View>
        ) : null}
        {otherForms.map((item, index) => this.renderFormCard(item, lastUsed.length + index))}
      </>
    );
  };

  componentDidMount() {
    if (branding === "iqops") {
      this.setState({
        isLoading: true,
        formData: [],
        formFiltered: [],
        formSelected: {},
        selectedTeamId: null,
      });
      this.props.setFormsFromAPI(this.props.formsFilter);
      this.props.getProductionCategories({ company_id: this.props.company_id });
      this.props.getTeams();
    } else if (!this.props.formsLoaded) {
      this.setState({
        isLoading: true,
      });
      this.props.setFormsFromAPI();
    } else {
      this.setState(
        {
          formData: this.props.formList,
          isLoading: false,
        },
        () => {
          this.filterForms(this.state.searchString, this.state.filterValue);
        }
      );
    }
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.formsFilter !== this.props.formsFilter && branding === "iqops") {
      this.setState({
        isLoading: true,
        formData: [],
        formFiltered: [],
        formSelected: {},
        selectedTeamId: null,
        selectedProductionCategory: null,
      });
    }
    if (this.props.route.params?.category != prevProps.route.params?.category) {
      this.filterForms(this.state.searchString, this.state.filterValue);
    }
    if (prevProps.formList !== this.props.formList) {
      this.setState(
        {
          formData: this.props.formList,
          isLoading: false,
        },
        () => {
          this.filterForms(this.state.searchString, this.state.filterValue);
        }
      );
    }
    if (prevProps.headerSearch !== this.props.headerSearch && branding === "iqops") {
      const search = this.props.headerSearch || "";
      this.setState({ searchString: search }, () => {
        this.filterForms(search, this.state.filterValue);
      });
    }
    if (prevProps.taskCreated !== this.props.taskCreated) {
      this.props.selectForm(
        this.state.formSelected._id,
        this.state.formSelected.title,
        this.props.previousSubmissions,
        this.props.taskCreated._id,
        this.state.formSelected?.promptMessages ? this.state.formSelected?.promptMessages : null,
        this.state.formSelected?.isPallet ? this.state.formSelected?.isPallet : null,
        this.state.formSelected?.isReceivingLog ? this.state.formSelected?.isReceivingLog : null,
        this.state.formSelected?.isOrder ? this.state.formSelected?.isOrder : null,
        this.state.formSelected?.isRecipe ? this.state.formSelected?.isRecipe : null,
        this.state.formSelected?.defaultYield ? this.state.formSelected?.defaultYield : null,
        this.state.formSelected?.isInvoice ? this.state.formSelected?.isInvoice : null,
        this.state.formSelected?.isShipmentLog ? this.state.formSelected?.isShipmentLog : null,
        this.state.formSelected?.isReconciliationLog ? this.state.formSelected?.isReconciliationLog : null,
        this.state.formSelected?.isInventoryTransfer ? this.state.formSelected?.isInventoryTransfer : null,
        this.state.formSelected?.scannerInput ? this.state.formSelected?.scannerInput : null,
        this.state.formSelected?.isShipmentByLocation ? this.state.formSelected?.isShipmentByLocation : null,
        this.state.formSelected?.isTransferByLocation ? this.state.formSelected?.isTransferByLocation : null,
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  registerNewTask = () => {
    const { formSelected } = this.state;
    if (!formSelected.title) {
      Swal.fire({
        title: "Please select a form",
        text: "You need to select a form in order to proceed.",
        confirmButtonText: "OK",
        confirmButtonColor: colors.orange,
        backdrop: false

      });
      return;
    }
    let start = moment.tz(new Date(), "UTC").format("YYYY-MM-DD HH:mm");
    let object = {
      name: formSelected.title,
      description: formSelected.title,
      forms_id: formSelected._id,
      start_date: start,
      expiration_date: moment(start).add(1, "day").format("YYYY-MM-DD HH:mm"),
      repeat_frequency: "",
      status: "archive",
      newRecord: true,
      from: 'New Reports'
    };
    this.props.createNewTask(object);
  };

  renderButtons = () => {
    let buttons = [];
    this.state.frequencies.forEach((item, index) => {
      buttons.push(
        <TouchableOpacity
          onPress={() => this.changeButton(index)}
          key={index + ""}
          style={[
            styles.button,
            {
              backgroundColor: item.isSelected
                ? colors.primary
                : colors.gray_darken_2,
            },
          ]}
        >
          <Text style={styles.buttonText}>{item.text}</Text>
        </TouchableOpacity>
      );
    });
    return buttons;
  };

  renderForms = () => {
    let formCards = [];
    this.state.formFiltered.forEach((item, index) => {
      formCards.push(
        <FormCard
          action={() => {
            this.selectForm(index);
            this.setState({
              formSelected: item,
            });
          }}
          index={index}
          formTitle={item.title}
          formSections={item.sections.length}
          formDescription={item.description}
          formImageUri={item.image}
          isSelected={item.isSelected}
        />
      );
    });
    return formCards;
  };

  render() {
    const { filterOptions, filterValue, searchString, isLoading } = this.state;
    const isIqops = branding === "iqops";

    const loadingBlock = !this.props.formsLoaded ? (
      <View
        style={{
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ActivityIndicator size="large" color={colors.primary} style={{ marginTop: 10 }} />
        <Text style={styles.txtLoading}>Loading forms, please wait.</Text>
      </View>
    ) : this.props.activeReload && branding === "ghcs" ? (
      <TouchableOpacity
        onPress={() => {
          this.setState({
            isLoading: true,
          }, () => this.props.setFormsFromAPI());
        }}
        style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", height: 30 }}>
        <Text style={{
          fontFamily: "Roboto-Bold",
          fontSize: 12,
          color: colors.subtitle,
        }}>Reload Forms</Text>
        <MaterialCommunityIcons
          name="refresh"
          style={{
            fontSize: 15,
            paddingHorizontal: 10,
            color: "gray",
          }}
        />
      </TouchableOpacity>
    ) : null;

    const formsBody = (
      <View style={isIqops ? styles.formsContainerIqops : { backgroundColor: colors.formsContainer, margin: 10, borderRadius: 20 }}>
        {isIqops
          ? this.renderIqopsFormsList()
          : this.state.formFiltered.map((item, index) => (
            !(item?.promptMessages?.visible == false) ?
              <FormCard
                key={index}
                action={() => {
                  if (item?.promptMessages?.category) {
                    this.props.setPromptTitle(item.name);
                    setTimeout(() => {
                      this.props.navigation.dispatch(StackActions.push('PromptFormView', { promptMessages: item?.promptMessages, form: item }));
                    }, 200)
                    return;
                  }
                  this.selectForm(index);
                  this.setState({
                    formSelected: item,
                  }, () => {
                    this.registerNewTask();
                  });
                }}
                index={index}
                formTitle={item.title}
                formDescription={item.description}
                formImageUri={item.image}
                isSelected={item.isSelected}
              />
              : null
          ))}
        {
          (!this.props.formsLoadedEnd && this.props.formsLoaded) &&
          <View
            style={{
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ActivityIndicator size="large" color={colors.primary} style={{ marginTop: 10 }} />
            <Text style={styles.txtLoading}>Loading forms, please wait.</Text>
          </View>
        }
      </View>
    );

    return (
      <View style={[
        { flexDirection: "row" },
        isIqops ? styles.screenShellIqops : null,
      ]}>
        <View style={{ flex: 1 }} />
        <View
          className={"viewContainer"}
          style={[
            viewContainer(this.state.width, styles),
            isIqops ? styles.viewContainerIqops : null,
          ]}
        >
          {isIqops ? (
            <View style={styles.iqopsColumn}>

              { this.props.formsFilter == "productionForms" ? this.renderProductionCategoriesBubbles() : this.renderTeamBubbles()}
              {loadingBlock}
              <ScrollView
                style={styles.iqopsScrollArea}
                contentContainerStyle={styles.iqopsScrollContent}
                showsVerticalScrollIndicator={false}
                keyboardShouldPersistTaps="handled"
              >
                {formsBody}
              </ScrollView>
            </View>
          ) : (
            <>
              <View style={{ display: "flex", justifyContent: "center" }}>
                <Text style={{
                  paddingLeft: 10,
                  textAlign: "center",
                  fontSize: 22,
                  fontFamily: "Roboto-Medium",
                  marginTop: 20,
                  marginBottom: 10,
                  color: colors.title

                }}>Add a new report</Text>
                <Text style={{
                  color: colors.tweny_black,
                  textAlign: "center",
                  fontSize: 16,
                  paddingLeft: 10,
                  paddingBottom: 10,
                  marginTop: 10,
                  fontFamily: "Roboto",
                }}>
                  Select the form you want to create your report from.
                </Text>
              </View>
              <View style={{
                height: 40,
                borderRadius: 20,
                flexDirection: "row",
                alignItems: "center",
                marginTop: 10,
                marginBottom: 10
              }}>
                <MaterialCommunityIcons
                  style={{ paddingLeft: 40 }}
                  name="magnify"
                  size={30}
                  color={colors.search_bar}
                />
                <TextInput
                  style={
                    {
                      borderRadius: 20,
                      flex: 1,
                      maxWidth: 450,
                      height: 30,
                      paddingTop: 10,
                      paddingRight: 10,
                      paddingBottom: 10,
                      paddingLeft: 20,
                      fontSize: 18,
                      color: colors.search_bar,
                    }
                  }
                  value={searchString}
                  placeholder="Search for a form"
                  onChangeText={(search) => {
                    this.setState({ searchString: search }, () => this.filterForms(search, filterValue))
                  }}
                  underlineColorAndroid="transparent"
                />
              </View>
              {loadingBlock}
              {formsBody}
              <View
                style={{
                  flex: 1,
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              />
            </>
          )}
        </View>
        <View style={{ flex: 1 }} />
      </View>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.user.get("authToken"),
    previousSubmissions: state.submissions.get("previousSubmissions"),
    formList: state.tasks.get("formList"),
    showTypesFilter: state.tasks.get("showTypesFilter"),
    taskCreated: state.tasks.get("taskCreated"),
    formsLoaded: state.tasks.get("formsLoaded"),
    formsLoadedEnd: state.tasks.get("formsLoadedEnd"),
    activeReload: state.tasks.get("activeReload"),
    headerSearch: state.user.get("headerSearch") || "",
    formsFilter: state.tasks.get("formsFilter"),
    teams: state.submissions.get("teams"),
    categories: state.submissions.get("productionCategories"),
    company_id: state.user.get("company_id"),
  };
};

export default connect(mapStateToProps, (dispatch, props) => {
  return {
    getTasks: () => {
      dispatch(getTasks());
    },
    setFilterSelected: () => {
      dispatch(setFilterSelected());
    },
    setFormSelected: () => {
      dispatch(setFormSelected());
    },
    setTaskSelected: () => {
      dispatch(setTaskSelected());
    },
    shouldReloadTasks: (value) => {
      dispatch(shouldReloadTasks(value));
    },
    setFormsFromAPI: (formsFilter) => {
      dispatch(setFormsFromAPI(formsFilter));
    },
    getTeams: () => {
      dispatch(getTeams());
    },
    getProductionCategories: (data) => {
      dispatch(getProductionCategories(data));
    },
    createNewTask: (task) => {
      return new Promise((resolve, reject) => {
        dispatch(setIsSubmission(false));
        dispatch(setSubmissionSelected(null));
        dispatch(createNewTask(task));
        resolve();
      });
    },
    setPromptTitle: (val) => {
      dispatch(setPromptTitle(val));
    },
    selectForm: (id, name, previousSubmissions, task_id, promptMessages, isPallet, isReceivingLog, isOrder, isRecipe, defaultYield, isInvoice, isShipmentLog, isReconciliationLog, isInventoryTransfer, scannerInput, isShipmentByLocation, isTransferByLocation) => {
      // if (!previousSubmissions[task_id]) {
      props.navigation.navigate('FormView', { formId: id, title: name, newReport: true, submission: false, task_id: task_id, log_group_id: null, promptMessages, isPallet, isReceivingLog, isOrder, isRecipe, defaultYield, isInvoice, isShipmentLog, isReconciliationLog, isInventoryTransfer, scannerInput, isShipmentByLocation, isTransferByLocation });
      return;
      // }

      // Swal.fire({
      //   title: "Open Report",
      //   text: "Would you like to start a new report, or reopen the previous report?",
      //   showCancelButton: true,
      //   showDenyButton: true,
      //   cancelButtonText: "Cancel",
      //   confirmButtonText: "New Report",
      //   denyButtonText: "Reopen Previous Report",
      //   confirmButtonColor: colors.orange,
      //   backdrop: false

      // }).then((result) => {
      //   if(result.isConfirmed) {
      //     dispatch(navigateForm(id, name, true, task_id));
      //   } else if (result.isDenied) {
      //     dispatch(navigateForm(id, name, false, task_id));
      //   }
      // });
    },
  };
})(NewTask);

const styles = StyleSheet.create({
  button: {
    alignItems: "center",
    borderRadius: 100,
    height: 60,
    justifyContent: "center",
    marginBottom: 10,
    marginRight: 20,
    marginTop: 10,
    minWidth: 160,
    overflow: "hidden",
    padding: 10,
  },
  buttonCreate: {
    height: 70,
    width: Dimensions.get("window").width,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.primary,
    shadowColor: "black",
    shadowOpacity: 0.2,
    shadowOffset: {
      width: 0,
      height: -4,
    },
    shadowRadius: 6,
  },
  buttonCreateText: {
    color: "white",
    fontSize: 18,
    fontWeight: "bold",
  },
  buttonText: {
    color: "white",
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
  },
  container: {
    backgroundColor: "#F8F8F8",
    flex: 1,
    justifyContent: "space-between",
  },
  input: {
    borderColor: colors.gray_darken_2,
    borderWidth: 1,
    borderRadius: 12,
    color: colors.gray_darken_2,
    fontFamily: "Roboto",
    fontSize: 18,
    height: 65,
    marginTop: 15,
    marginBottom: 15,
    paddingBottom: 0,
    paddingLeft: 20,
  },
  inputSearch: {
    flex: 1,
    height: 70,
    paddingTop: 10,
    paddingRight: 10,
    paddingBottom: 10,
    paddingLeft: 20,
    fontSize: 18,
    backgroundColor: "#fff",
    color: "#90A4AE",
  },
  labelInput: {
    color: colors.blue_gray,
    fontSize: 18,
    paddingLeft: 10,
    paddingBottom: 10,
    marginTop: 10,
    fontFamily: "Roboto",
  },
  title: {
    paddingLeft: 10,
    fontSize: 22,
    fontFamily: "Roboto-Medium",
    marginTop: 20,
    marginBottom: 10,
  },
  searchSection: {
    height: 70,
    flexDirection: "row",
    backgroundColor: "#fff",
    alignItems: "center",
    marginBottom: 10,
  },
  searchContainer: {
    flex: 1,
    marginTop: 5,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  searchIcon: {
    paddingLeft: 20,
  },
  subtitle: {
    color: colors.black,
    fontSize: 16,
    paddingLeft: 10,
    paddingBottom: 10,
    marginTop: 10,
    fontFamily: "Roboto-Italic",
  },
  whiteSection: {
    backgroundColor: "#fff",
    marginTop: 20,
    padding: 10,
  },
  viewContainerMax: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 20,
    marginTop: 10,
    minWidth: '80%',
    paddingTop: 50,
    paddingLeft: 50,
    paddingRight: 50,
  },
  viewContainerMax1: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 20,
    marginTop: 10,
    minWidth: 450,
    paddingTop: 20,
    paddingLeft: 15,
    paddingRight: 15,
  },
  viewContainerMax2: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 20,
    marginTop: 10,
    minWidth: 350,
    paddingTop: 50,
    paddingLeft: 10,
    paddingRight: 10,
  },
  viewContainerMax3: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 20,
    marginTop: 10,
    minWidth: 300,
    paddingTop: 50,
    paddingLeft: 10,
    paddingRight: 10,
  },
  refreshIcon: {
    fontSize: 15,
    paddingHorizontal: 10,
    color: "gray",
  },
  txtLoading: {
    fontSize: 16,
    color: colors.blue_gray,
    margin: 10,
    fontWeight: 600
  },
  btnFilter: {
    width: '50%',
    textAlign: 'center',
    borderRadius: 5,
    padding: 5
  },
  formsContainerIqops: {
    backgroundColor: "#FFFFFF",
    margin: 0,
    borderRadius: 0,
    paddingTop: 4,
  },
  screenShellIqops: {
    flex: 1,
    height: "100%",
    maxHeight: "100%",
    overflow: "hidden",
    backgroundColor: "#FFFFFF",
  },
  viewContainerIqops: {
    flex: 1,
    height: "100%",
    maxHeight: "100%",
    overflow: "hidden",
    marginTop: 0,
    borderRadius: 0,
    paddingTop: 8,
    backgroundColor: "#FFFFFF",
  },
  iqopsColumn: {
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
  },
  iqopsScrollArea: {
    flex: 1,
    minHeight: 0,
  },
  iqopsScrollContent: {
    paddingBottom: 120,
    flexGrow: 1,
  },
  teamBubblesScroll: {
    flexGrow: 0,
    flexShrink: 0,
  },
  teamBubblesContent: {
    paddingHorizontal: 16,
    paddingTop: 8,
    paddingBottom: 10,
    alignItems: "center",
  },
  teamBubble: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F3F4F6",
    borderRadius: 20,
    paddingVertical: 8,
    paddingHorizontal: 14,
    marginRight: 10,
    borderWidth: 1,
    borderColor: "#E8EEF5",
  },
  teamBubbleActive: {
    backgroundColor: "#5A5A5A",
    borderColor: "#5A5A5A",
  },
  teamBubbleIcon: {
    marginRight: 6,
  },
  teamBubbleLabel: {
    fontSize: 14,
    fontWeight: "600",
    color: "#1A1A1A",
    //maxWidth: 120,
  },
  teamBubbleLabelActive: {
    color: "#FFFFFF",
  },
  lastUsedSection: {
    marginHorizontal: 16,
    marginTop: 8,
    marginBottom: 12,
  },
  lastUsedTitle: {
    color: "#5B9BD5",
    fontSize: 14,
    fontWeight: "500",
    marginBottom: 8,
    marginLeft: 2,
  },
  lastUsedGroup: {
    borderWidth: 1.5,
    borderColor: "#A8C8E8",
    borderRadius: 10,
    backgroundColor: "#FFFFFF",
    overflow: "hidden",
  },
});
